import { useNavigate } from "react-router-dom";

import styled from "styled-components";

import { fontStyles } from "../style/common_font";

import { RowView2 } from "../style/common_style";



import { PlatformBusinessDetails } from "./Footer";

interface SellerBusinessInfo {
  seq?: number;
  com_name?: string;
  rep_name?: string;
  business_reg_number?: string | null;
  mail_order_registration_number?: string | null;
  business_type?: string | null;
  business_item?: string | null;
  store_phone?: string;
  store_email?: string;
  addr_num?: string;
  addr_basic?: string;
  addr_detail?: string;
}

const SellerFooter = ({ store }: { store: SellerBusinessInfo }) => {
  const Navigate = useNavigate();



  const go_rule = () => Navigate(store.seq ? `/rule-seller/1?storeSeq=${store.seq}` : '/rule/1');
  const go_rule2 = () => Navigate(store.seq ? `/rule-seller/2?storeSeq=${store.seq}` : '/rule/2');


  return (

    <FooterArea>

      <Rule>

        <div onClick={go_rule}>이용약관</div>

        <div onClick={go_rule2}>개인정보처리방침</div>

      </Rule>

      <Hr />



      <InfoBox>
        {store.seq === 1 ? <>
        {store.com_name && <div>상호 : {store.com_name}</div>}
        {store.rep_name && <div>대표자 : {store.rep_name}</div>}
        {store.business_reg_number && <div>사업자등록번호 : {store.business_reg_number}</div>}
        {store.mail_order_registration_number && <div>통신판매업 신고번호 : {store.mail_order_registration_number}</div>}
        {store.business_type && <div>업태 : {store.business_type}</div>}
        {store.business_item && <div>종목 : {store.business_item}</div>}
        {(store.addr_num || store.addr_basic || store.addr_detail) && <div>사업장 주소 : {[store.addr_num && `(${store.addr_num})`, store.addr_basic, store.addr_detail].filter(Boolean).join(" ")}</div>}
        {store.store_phone && <div>연락처 : {store.store_phone}</div>}
        {store.store_email && <div>E-mail : {store.store_email}</div>}
      </> : <PlatformBusinessDetails />}
      </InfoBox>

    </FooterArea>

  );

};



export default SellerFooter;



const FooterArea = styled.div`
  padding: 0rem 1rem 2rem 1rem;
  margin-top: 2rem;
  color: var(--user-text-muted, #717171);
`;

const Rule = styled(RowView2)`

  ${fontStyles.semiBold}

  div {

    margin-right: 1rem;

    cursor: pointer;

  }

`;

const Hr = styled.div`
  width: 100%;

  height: 1px;

  margin: 1rem 0rem;

  background-color: var(--user-border, #474747);
`;
const InfoBox = styled.div`

  font-size: 14px;

  line-height: 25px;

  span {

    margin-left: 1.5rem;

  }

  div.click {

    cursor: pointer;

  }

`;

